// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"7509f9e6","163":"09656b99","453":"97633d6c","952":"fad45b8f"}[chunkId] + ".chunk.js";
};